import { type PropsWithChildren } from 'react';
import { LaunchDarklyProvider } from '@sg/launch-darkly';

import { getEnvVars } from '@order/utils';

import { featureFlagDefaults, featureFlagOverrides } from '../feature-flags';
import { LaunchDarklyProviderContext } from './LaunchDarklyProviderContext';

// ─────────────────────────────────────────────────────────────────────────────

export const OrderLaunchDarklyProvider = (props: PropsWithChildren) => {
  return (
    <LaunchDarklyProvider
      Context={LaunchDarklyProviderContext}
      defaultFlags={featureFlagDefaults}
      localOverrides={featureFlagOverrides}
      webClientSideID={LAUNCHDARKLY_CLIENT_ID}
      mobileClientSideID={LAUNCHDARKLY_MOBILE_KEY}
    >
      {props.children}
    </LaunchDarklyProvider>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const { LAUNCHDARKLY_CLIENT_ID, LAUNCHDARKLY_MOBILE_KEY } = getEnvVars();
